import React, { useEffect } from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';

import { ImageSingleChoiceAnswerItem } from '../../../private/LearnEngineComponents/ImageSingleChoiceAnswerItem/ImageSingleChoiceAnswerItem';
import { AnswerOptionStatus, IAnswerOption } from '../../../../api/private/learn-engine-api/learn-engine-api.interface';
import { ISlAnswerProps } from '../../globalInterfaces/learnEngineInterfaces';

import s from './SlImageSingleChoiceAnswer.scss';

export function SlImageSingleChoiceAnswer({
	options,
	onChange,
	isValid,
}: ISlAnswerProps): JSX.Element {
	useStyles(s);

	useEffect(() => {
		onChange(
			options.sort((a, b) => a.orderNumber - b.orderNumber).map((o) => ({
				...o,
				status: AnswerOptionStatus.Initial,
			})),
		);
	}, []);

	if (!options?.length || options.find((o) => !o.status)) {
		return null;
	}

	const onOptionSelect = (selectedOptionId: number) => {
		const changedOptions: IAnswerOption[] = options.map(
			(option: IAnswerOption) => ({
				...option,
				status: option.id === selectedOptionId
					? AnswerOptionStatus.Selected
					: AnswerOptionStatus.Initial,
			}),
		);
		isValid(true);
		onChange(changedOptions);
	};

	const items: IAnswerOption[][] = [];

	for (let i = 0; i < options.length; i += 2) {
		items.push([options[i], options[i + 1]]);
	}

	return (
		<>
			{items.map((pair, i) => (
				<div className="sl-image-single-choice-answers" key={i}>
					{pair.map((option) => (
						<ImageSingleChoiceAnswerItem
							key={option.id}
							option={option}
							onSelectOption={() => onOptionSelect(option.id)}
						/>
					))}
				</div>
			))}
		</>
	);
}
